import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import devices from '../../common/styles/devices';
import { FONT_FAMILY } from '@Commons';

export const ModalContainer = styled.div`
  background-color: ${COLORS.white};
  border-radius: 10px;
  padding: 16px 16px 32px;
  width: 100%;
  max-width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  flex-direction: column;
  min-width: 400px;
  .proceed-btn {
    margin-top: 30px;
    border-radius: 50px;
  }
  .deeplink-container {
    width: 100%;
    text-align: center;
    margin-top: 16px;
  }
  @media ${devices.mobileXL} {
    min-width: unset;
    width: 90%;
  }
`;

export const CloseWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  padding: 10px;
  cursor: pointer;
`;

export const WarningImgContainer = styled.div`
  margin-bottom: 8px;
`;
export const TitleText = styled.p`
  font-size: 18px;
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
`;

export const MessageText = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${COLORS.textGrey};
  text-align: center;
  line-height: 24px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 10px;
  text-align: center;
`;

export const ExpiryContainer = styled.div`
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 2px;
  overflow: hidden;
  margin-top: 20px;
  max-width: 335px;
`;

export const ExpiryDateRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.textGrey};

  img {
    width: 18px;
    height: 18px;
  }
`;

export const ExpiryDateValue = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
`;

export const ExpiryHintRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: ${COLORS.lightestPink};
  font-size: 12px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textGrey};

  img {
    width: 18px;
    height: 18px;
  }
`;
